export default __webpack_public_path__ + "static/undraw_businessman_97x4-68e068e9c086ed56cd2632107c1f6df3.svg";